import { useNode } from "@craftjs/core";
import React, { useEffect, useState } from "react";
import { ASSETS } from "../../../../utils/config";
import { sliderToPercentage } from "../../../../utils/helpers";
import CustomTabs from "../../Shared/CustomTabs";
import MediaSelection from "../../Shared/MediaSelection";
import Layout from "./Layout";
import List from "./List";
import { useDispatch, useSelector } from "react-redux";
import { updateImageGridStyles } from "../../../../redux/reducers/PrevStylesCopy/CodeblockDefaultStyles";

const ImageGridSettings = () => {
  const {
    actions: { setProp },
    width,
    isApplyMarginOnAllSides,
    margin,
    allSideMargin,
    borderRadius,
    borderColor,
    borderWidth,
    src,
    title,
    showCaptions,
    hyperlink,
    showHyperlink,
    dropShadowColor,
    originalSrc,
    gridType,
    alignment,
    images,
    shallowImages,
    columns,
  } = useNode((node) => ({
    width: node.data.props.width,
    isApplyMarginOnAllSides: node.data.props.isApplyMarginOnAllSides,
    margin: node.data.props.margin,
    allSideMargin: node.data.props.allSideMargin,
    borderRadius: node.data.props.borderRadius,
    borderWidth: node.data.props.borderWidth,
    borderColor: node.data.props.borderColor,
    src: node.data.props.src,
    title: node.data.props.title,
    showCaptions: node.data.props.showCaptions,
    hyperlink: node.data.props.hyperlink,
    showHyperlink: node.data.props.showHyperlink,
    dropShadowColor: node.data.props.dropShadowColor,
    originalSrc: node.data.props.originalSrc || node.data.props.src,
    gridType: node.data.props.gridType,
    images: node.data.props.images,
    shallowImages: node.data.props.shallowImages,
    columns: node.data.props.columns,
  }));

  const [selectedTab, setSelectedTab] = useState("0");

  const dispatch = useDispatch();
  const { imageGrid: imageGridProps } = useSelector((state) => state.codeblockStyles);

  useEffect(() => {
    // Set originalSrc if it's not set
    if (!originalSrc) {
      setProp((props) => {
        props.originalSrc = src;
      });
    }
  }, [originalSrc, src, setProp]);

  // useEffect(() => {
  //   // When the component mounts, update the imageGridProps in Redux
  //   // This ensures the latest property values are synchronized to global state
  //   const updatedImageGridProps = {
  //     ...imageGridProps,
  //     margin: margin || imageGridProps.margin,
  //     isApplyMarginOnAllSides: isApplyMarginOnAllSides,
  //     allSideMargin: allSideMargin || imageGridProps.allSideMargin,
  //     borderRadius: borderRadius || imageGridProps.borderRadius,
  //     borderWidth: borderWidth || imageGridProps.borderWidth,
  //     borderColor: borderColor || imageGridProps.borderColor,
  //     dropShadowColor: dropShadowColor || imageGridProps.dropShadowColor,
  //     alignment: alignment || imageGridProps.alignment,
  //     showCaptions: showCaptions,
  //     gridType: gridType || imageGridProps.gridType,
  //     columns: columns || imageGridProps.columns
  //   };
    
  //   // Dispatch to update the global imageGrid props
  //   dispatch(updateImageGridStyles(updatedImageGridProps));
  // }, []);

  const handleAdjustment = (side, operation) => {
    const newValue =
      operation === "increase" ? margin[side] + 1 : margin[side] - 1;
    if (newValue >= 0) handleChange("margin", newValue, side);
  };

  const handleChange = (type, value, side) => {
    setProp((props) => {
      switch (type) {
        case "width":
          props.width = sliderToPercentage(value);
          break;
        case "margin":
          if (value >= 0 && value <= 100) props.margin[side] = value;
          break;
        case "allSideMargin":
          props.allSideMargin = value;
          break;
        case "marginCheckbox":
          props.isApplyMarginOnAllSides = !props.isApplyMarginOnAllSides;
          break;
        case "border":
          props.borderRadius = value;
          break;
        case "borderColor":
          props.borderColor = value;
          break;
        case "resetColor":
          props.borderColor = null;
          break;
        case "borderWidth":
          props.borderWidth = value;
          break;
        case "image":
          props.images.push(value);
          props.shallowImages.push(value);
          break;

        case "images":
          const existingIndex = props.images.findIndex(
            (image) => image.id === value.id
          );

          if (existingIndex !== -1) {
            props.images[existingIndex] = {
              ...props.images[existingIndex],
              ...value,
            };
          } else {
            props.images.push(value);
          }

          break;

        case "newImages":
          props.images = value;
          break;
        case "shallowImages":
          props.shallowImages = value;
          break;
        case "title":
          props.title = value;
          break;
        case "showCaptions":
          props.showCaptions = !props.showCaptions;
          break;
        case "showHyperlink":
          props.showHyperlink = !props.showHyperlink;
          break;
        case "hyperlink":
          props.hyperlink = value;
          break;
        case "dropShadowColor":
          props.dropShadowColor = value;
          break;
        case "resetShadow":
          props.dropShadowColor = null;
          break;
        case "gridType":
          props.gridType = value;
          break;
        case "columns":
          props.columns = value;
          break;
      }
    }, 500);

    const updatedImageGridProps = { ...imageGridProps };
    
    switch (type) {
      case "margin":
        if (side && value >= 0 && value <= 100) {
          updatedImageGridProps.margin = {
            ...updatedImageGridProps.margin,
            [side]: value
          };
        }
        break;
      case "allSideMargin":
        updatedImageGridProps.allSideMargin = value;
        break;
      case "marginCheckbox":
        updatedImageGridProps.isApplyMarginOnAllSides = !isApplyMarginOnAllSides;
        break;
      case "border":
        updatedImageGridProps.borderRadius = value;
        break;
      case "borderColor":
        updatedImageGridProps.borderColor = value;
        break;
      case "resetColor":
        updatedImageGridProps.borderColor = null;
        break;
      case "borderWidth":
        updatedImageGridProps.borderWidth = value;
        break;
      case "dropShadowColor":
        updatedImageGridProps.dropShadowColor = value;
        break;
      case "resetShadow":
        updatedImageGridProps.dropShadowColor = null;
        break;
      case "gridType":
        updatedImageGridProps.gridType = value;
        break;
      case "showCaptions":
        updatedImageGridProps.showCaptions = !showCaptions;
        break;
      case "columns":
        updatedImageGridProps.columns = value;
        break;
    }
    
    console.log("Updating imageGrid props in Redux:", type, updatedImageGridProps);
    dispatch(updateImageGridStyles(updatedImageGridProps));
  };

  const handleTabChange = (e, newVal) => {
    setSelectedTab(newVal);
  };

  const tabOptions = new Map([
    [
      "0",
      {
        label: `List ${images.length ? "(" + images.length + ")" : ""}`,
        component: (
          <List
            images={images}
            setImages={(images) => handleChange("newImages", images)}
            shallowImages={shallowImages}
            setShallowImages={(images) => handleChange("shallowImages", images)}
            onClickAdd={() => setSelectedTab("1")}
          />
        ),
      },
    ],
    [
      "1",
      {
        label: "Add Images",
        component: (
          <MediaSelection
            type="images"
            handleChange={handleChange}
            isGifAllowed
            media={images}
            setMedia={(images) => handleChange("newImages", images)}
          />
        ),
      },
    ],
    [
      "2",
      {
        label: "Layout",
        disabled:images.length==0,
        component: (
          <Layout
            setProp={setProp}
            margin={margin}
            isApplyMarginOnAllSides={isApplyMarginOnAllSides}
            allSideMargin={allSideMargin}
            borderRadius={borderRadius}
            borderWidth={borderWidth}
            borderColor={borderColor}
            dropShadowColor={dropShadowColor}
            showCaptions={showCaptions}
            gridType={gridType}
            handleAdjustment={handleAdjustment}
            handleChange={handleChange}
            columns={columns}
          />
        ),
      },
    ],
  ]);

  return (
    <>
      <CustomTabs
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        options={tabOptions}
      />
    </>
  );
};

export default ImageGridSettings;
